import { RuntimeConfig } from '@/types/configuration.type';

/**
 * Push the tenant theme into `:root` as CSS custom properties, so build-time
 * SCSS (`variable.scss` aliases `$primaryColor` → `var(--color-primary)` etc.)
 * picks up the runtime colors. No-op when the config carries no theme.
 */
export const applyRuntimeTheme = (
  theme: NonNullable<RuntimeConfig['style']>['theme']
) => {
  if (!theme) {
    return;
  }
  const root = document.documentElement;
  root.style.setProperty('--color-primary', theme.primary);
  root.style.setProperty('--color-secondary', theme.secondary);
  root.style.setProperty('--color-bg', theme.bg);
};
